export default __webpack_public_path__ + "static/operations-c848851f682c57b8b374be489d7d00a1.svg";